export default __webpack_public_path__ + "static/media/tete50.b1e66de3.png";